import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { setRequireCloseModal } from '../../../../../slices/screen/reducer';
import { addNewGraph, updateGraph } from '../../../../../slices/thunks';


const GraphForm = ({ dataGraph, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const selectorGraph = createSelector(
		state => state.Screen,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal
		})
	);
	const { isAdding, isAdded, isUpdating, isUpdated, isLoadingList, requireCloseModal } = useSelector(selectorGraph);

	// Validation
	const validation = useFormik({
		// Enable reinitialize when initial values need to be changed
		enableReinitialize: true,
		initialValues: {
			name: dataGraph?.name || '',
			description: dataGraph?.description || '',
			code: dataGraph?.code || '',
			thumbnail_image: dataGraph?.thumbnail_image || '',
			level: dataGraph?.level || '',
		},
		validationSchema: Yup.object({
			name: Yup.string().required('Campo requerido'),
			description: Yup.string().required('Campo requerido'),
			code: Yup.string().required('Campo requerido'),
			thumbnail_image: Yup.string().required('Campo requerido'),
			level: Yup.string().required('Campo requerido'),
		}),
		validateOnChange: true, // Validate on field change
		onSubmit: async values => {
			try {
				const graphData = {
					...values,
					...(isEdit && { _id: dataGraph._id }),
				};

				if (isEdit) {
					await dispatch(updateGraph(graphData));
				} else {
					await dispatch(addNewGraph(graphData));
				}
			} finally {
				dispatch(setRequireCloseModal(true));
			}
		},
	});





	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				{/* <TabContent activeTab={activeTab}>
					<TabPane tabId='1'> */}
				<Row className='g-3'>
					<Col lg={12}>
						<Label for='name' className='form-label'>
							Nombre del gráfico
						</Label>
						<Input
							name='name'
							id='name'
							className='form-control'
							placeholder='Ingrese el nombre del gráfico'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.name || ''}
							invalid={
								validation.touched.name &&
									validation.errors.name
									? true
									: false
							}
						/>
						{
							validation.touched.name &&
								validation.errors.name ? (
								<FormFeedback type='invalid'>
									{validation.errors.name}
								</FormFeedback>
							) : null
						}
					</Col>
					<Col lg={12}>
						<Label for='description' className='form-label'>
							Descripción
						</Label>
						<Input
							name='description'
							id='description'
							className='form-control'
							placeholder='Ingrese el nombre del gráfico'
							type='textarea'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.description || ''}
							invalid={
								validation.touched.description &&
									validation.errors.description
									? true
									: false
							}
						/>
						{
							validation.touched.description &&
								validation.errors.description ? (
								<FormFeedback type='invalid'>
									{validation.errors.description}
								</FormFeedback>
							) : null
						}
					</Col>
					<Col lg={5}>
						<Label for='code' className='form-label'>
							Código
						</Label>
						<Input
							name='code'
							id='code'
							className='form-control'
							placeholder='Ingrese el código'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.code || ''}
							invalid={
								validation.touched.code &&
									validation.errors.code
									? true
									: false
							}
						/>
						{
							validation.touched.code &&
								validation.errors.code ? (
								<FormFeedback type='invalid'>
									{validation.errors.code}
								</FormFeedback>
							) : null
						}
					</Col>
					<Col lg={5}>
						<Label for='thumbnail_image' className='form-label'>
							Imagen
						</Label>
						<Input
							name='thumbnail_image'
							id='thumbnail_image'
							className='form-control'
							placeholder='Ingrese el nombre de la imagen'
							type='text'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.thumbnail_image || ''}
							invalid={
								validation.touched.thumbnail_image &&
									validation.errors.thumbnail_image
									? true
									: false
							}
						/>
						{
							validation.touched.thumbnail_image &&
								validation.errors.thumbnail_image ? (
								<FormFeedback type='invalid'>
									{validation.errors.thumbnail_image}
								</FormFeedback>
							) : null
						}
					</Col>
					<Col lg={2}>
						<Label for='level' className='form-label'>
							Orden
						</Label>
						<Input
							name='level'
							id='level'
							className='form-control'
							placeholder='Ingrese el el orden'
							type='number'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.level || ''}
							invalid={
								validation.touched.level &&
									validation.errors.level
									? true
									: false
							}
						/>
						{
							validation.touched.level &&
								validation.errors.level ? (
								<FormFeedback type='invalid'>
									{validation.errors.level}
								</FormFeedback>
							) : null
						}
					</Col>
				</Row>
				{/* </TabPane>
				</TabContent> */}
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isAdding || isUpdating}
					>
						{isAdding || isUpdating ? (
							<i className="label-icon"><Spinner size='sm' /></i>
						) : <i className="ri-save-3-line label-icon"></i>}
						{isEdit ? 'Editar' : 'Crear'} Gráfico
					</button>
				</div>
			</div>
		</Form>
	);
};

export default GraphForm;
